export default __webpack_public_path__ + "static/media/IMG-20230628-WA0043.222a5852.jpg";